import styled from '@emotion/styled';

export {
	AuthContainer as Container,
	AuthEyebrow as Eyebrow,
	AuthFieldBox as FieldBox,
	AuthFormActions as FormActions,
	AuthFormCard as FormCard,
	AuthPage as Page,
	AuthPageHeader as PageHeader,
	AuthSubtitle as Subtitle,
	AuthTitle as Title,
} from '@/styles/authPageLayout';

export { FindButton, PrimaryButton as Button } from '@/components/common/Button/style';

export const InnerForm = styled.form`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

/** 인증번호 + 인증 버튼 한 줄 */
export const VerifyRow = styled.div`
	display: flex;
	flex-wrap: nowrap;
	align-items: stretch;
	gap: ${(props) => props.theme.scale.spaceSm};
	width: 100%;
	margin-top: ${(props) => props.theme.scale.spaceSm};

	& > div:first-of-type {
		flex: 1 1 0;
		min-width: 0;
	}

	& > button {
		flex: 0 0 auto;
		align-self: stretch;
	}
`;

export const Danger = styled.p`
	margin: 0;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	color: ${(props) => props.theme.colors.red600};
	line-height: 1.4;
`;
